import AccountSetupItem from './AccountSetupItem';

export default AccountSetupItem;
